module.exports = __webpack_public_path__ + "static/media/mapRefrigoexample.5863e48e.png";